import { useEffect } from 'react';
// Import the hook file directly (not the barrel) to avoid a circular import
// with providers/authorisation/provider, which renders this component.
import useAuthorisation from 'providers/authorisation/use';
import { identifyUser } from './posthog';

// Identifies the signed-in user with PostHog once the authorisation context
// has resolved. identifyUser is idempotent per email, so re-renders are cheap.
const AnalyticsIdentifier = () => {
  const { state: { user } } = useAuthorisation();

  useEffect(() => {
    if (user) {
      identifyUser({ email: user.email, name: user.name, roles: user.roles });
    }
  }, [user?.email]);

  return null;
};

export default AnalyticsIdentifier;
